import React from 'react';
import ArticleEditor from '../../components/Lexical/ArticleEditor';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return <ArticleEditor />;
};
